import { t } from "@lingui/macro";
import { X } from "@phosphor-icons/react";
import { ScrollArea } from "@stylingcv/ui";

import { useBuilderStore } from "@/client/stores/builder";

import { BackgroundSection } from "./sections/background";
import { ExportSection } from "./sections/export";
import { InformationSection } from "./sections/information";
import { LayoutSection } from "./sections/layout";
import { NotesSection } from "./sections/notes";
import { PageSection } from "./sections/page";
import { PictureSection } from "./sections/picture";
import { SharingSection } from "./sections/sharing";
import { StatisticsSection } from "./sections/statistics";
import { TemplateSection } from "./sections/template";
import { ThemeSection } from "./sections/theme";
import { TypographySection } from "./sections/typography";

export const RightSidebar = () => {
  const setLeftPanelMode = useBuilderStore((state) => state.setLeftPanelMode);
  const setActiveTab = useBuilderStore((state) => state.setActiveTab);

  return (
    <div className="flex h-full flex-col bg-white">
      {/* Header */}
      <div className="flex h-14 shrink-0 items-center justify-between border-b border-gray-200 px-4">
        <span className="font-heading text-[15px] font-bold text-[#16344c]">
          {t`Design`}<span className="text-[#268599] ml-1">{t`Settings`}</span>
        </span>
        <button
          onClick={() => { setLeftPanelMode("content"); setActiveTab("fill-in"); }}
          className="flex size-8 items-center justify-center rounded-lg text-gray-400 transition-colors hover:bg-gray-100 hover:text-[#16344c]"
          aria-label="Close design settings"
        >
          <X size={16} weight="bold" />
        </button>
      </div>

      {/* Flat scrollable sections */}
      <ScrollArea orientation="vertical" className="flex-1 bg-gray-50">
        <div className="px-[2rem] py-6 space-y-12 pb-28">
          <TemplateSection />
          <TypographySection />
          <LayoutSection />
          <ThemeSection />
          <PageSection />
          <PictureSection />
          <BackgroundSection />
          <ExportSection />
          <NotesSection />
          <SharingSection />
          <StatisticsSection />
          <InformationSection />
        </div>
      </ScrollArea>
    </div>
  );
};
